import { Mapper } from "../../../../../core/base";
import { Location } from "../../../../../core/domain";
import { LocationWebEntity } from "./location-web-entity";
import { DateTime, Duration } from "luxon";

export class LocationWebRepositoryMapper extends Mapper<LocationWebEntity, Location> {
  mapFrom(param: LocationWebEntity): Location {
    return {
      id: param.id,
      activityName : param.activityName,
      locationId: param.locationId,
      locationName: param.locationName,
      address: param.address,
      postalCode: param.postalCode,
      latitude: param.latitude,
      longitude: param.longitude,
      template:param.template,
      city: param.city,
      country: param.country,
      countryCode:param.countryCode,
      stopTime: param.stopTime ? Duration.fromISOTime(param.stopTime!) : undefined,
      serviceTime: param.serviceTime ? Duration.fromISOTime(param.serviceTime!) : undefined,      
      serviceFromTime: param.serviceFromTime ? Duration.fromISOTime(param.serviceFromTime!) : undefined,
      serviceToTime : param.serviceToTime ? Duration.fromISOTime(param.serviceToTime!) : undefined,
      pickupCapacityType1: param.pickupCapacityType1,
      pickupCapacityType2:param.pickupCapacityType2,
      pickupCapacityType3:param.pickupCapacityType3,
      deliveryCapacityType1: param.deliveryCapacityType1,
      deliveryCapacityType2:param.deliveryCapacityType2,
      deliveryCapacityType3: param.deliveryCapacityType3,
      precedence: param.precedence,
      qualifications: param.qualifications,
      jobNumber: param.jobNumber,
      planName: param.planName,
      planId: param.planId,
      jobId: param.jobId,
      createdAt: DateTime.fromISO(param.createdAt ?? ""),
      servicesCount: param.servicesCount,
      isScheduled: param.isScheduled,
      stopNumber: param.stopNumber,
      sequenceNumber: param.sequenceNumber,
      services: param.services,
      distributionLaneId: param.distributionLaneId,
      isEndTerminal: param.isEndTerminal,
      isStartTerminal: param.isStartTerminal,
      openHours:param.openHours,
      segment: param.segment,  
      productId:param.productId,
      productName: param.productName,
      arrivalTime:  (param.arrivalTime) ? DateTime.fromISO(param.arrivalTime) : undefined,
      departureTime: (param.departureTime) ? DateTime.fromISO(param.departureTime) : undefined,
      locationAdditionalInfo :param.locationAdditionalInfo,
      productAdditionalInfo :param.productAdditionalInfo,
      tenantLocationId :param.tenantLocationId,
      day :param.day,
      customData: param.customData,
      closedDay: param.closedDay,
      shouldVisitIfNoService: param.shouldVisitIfNoService
    };
  }

  mapTo(param: Location): LocationWebEntity {
    return {
      id: param.id,
      activityName : param.activityName,
      locationId: param.locationId,
      locationName: param.locationName,
      address: param.address,
      postalCode: param.postalCode,
      city: param.city,
      country: param.country,
      stopTime: param.stopTime?.toISOTime(),
      latitude: param.latitude,
      longitude: param.longitude,
      template:param.template,
      jobNumber: param.jobNumber,
      planName: param.planName,
      serviceTime: param.serviceTime?.toISOTime(),
      serviceFromTime: param.serviceFromTime?.toISOTime(),
      serviceToTime: param.serviceToTime?.toISOTime(),
      pickupCapacityType1: param.pickupCapacityType1,
      pickupCapacityType2:param.pickupCapacityType2,
      pickupCapacityType3:param.pickupCapacityType3,
      deliveryCapacityType1: param.deliveryCapacityType1,
      deliveryCapacityType2:param.deliveryCapacityType2,
      deliveryCapacityType3: param.deliveryCapacityType3,
      precedence: param.precedence,
      qualifications: param.qualifications,
      planId: param.planId,
      jobId: param.jobId,
      servicesCount: param.servicesCount,
      isScheduled: param.isScheduled,
      sequenceNumber: param.sequenceNumber,
      createdAt: param.createdAt.toISO(),
      distributionLaneId: param.distributionLaneId,
      isEndTerminal: param.isEndTerminal,
      isStartTerminal: param.isStartTerminal, 
      openHours:param.openHours,
      segment: param.segment,
      prodId: param.prodId || '',
      productId: param.productId || '',
      productName: param.productName || '',
      stopNumber: param.stopNumber,
      customData: param.customData,
      locationAdditionalInfo :param.locationAdditionalInfo,
      productAdditionalInfo :param.productAdditionalInfo,
      tenantLocationId :param.tenantLocationId,
      day :param.day,
      closedDay: param.closedDay,
      shouldVisitIfNoService: param.shouldVisitIfNoService
    };
  }
}
